<div class="card">
    <h3 class="card-header">{{resources.ConsumingPlanningAreaMappingAdd}}</h3>
    <div class="card-body">
        <div class="container-fluid">
            <form [formGroup]="addCPAMappingForm" (ngSubmit)="onSave()">
                <div class="row">
                    <div class="form-group col-md-2">
                        <label>{{resources.From}}</label>
                        <div class="input-group">
                            <input formControlName="cpaMappingFrom" type="text" class="form-control"
                                placeholder="{{resources.From}}" required />
                        </div>
                    </div>
                    <div class="form-group col-md-2">
                        <label>{{resources.To}}</label>
                        <div class="input-group">
                            <input formControlName="cpaMappingTo" type="text" class="form-control"
                                placeholder="{{resources.To}}" required />
                        </div>
                    </div>
                    <div class="form-group col-md-2">
                        <label>{{resources.ValidFrom}}</label>
                        <div class="input-group">
                            <input formControlName="cpaMappingValidFrom" type="date" class="form-control" max="9999-12-31"  min="{{minFromDate|date:'yyyy-MM-dd'}}"
                                required />
                        </div>
                    </div>
                    <div class="form-group col-md-2">
                        <label>{{resources.ValidTo}}</label>
                        <div class="input-group">
                            <input formControlName="cpaMappingValidTo" type="date" class="form-control" max="9999-12-31"
                                required />
                        </div>
                    </div>
                    <div class="form-group col-md-2">
                        <label>&nbsp;</label>
                        <button class="btn btn-sm btn-primary form-control" id="saveCPAMapping" type="submit">
                            <i class="fas fa-lg fa-save"></i>&nbsp; {{resources.Save}}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
<br />
